// extracted by mini-css-extract-plugin
export default {"uafPattern":"uaf-pattern_uafPattern__vBN7c","container":"uaf-pattern_container__a4Bu+"};